<template>
    <div class="modal" tabindex="-1" role="dialog" :id="modalId" :aria-labelledby="`${modalId}-title`">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content unsaved-modal">
                <div class="modal-body">
                    <span class="unsaved-modal-icon" aria-hidden="true">
                        <fa icon="exclamation-triangle" />
                    </span>

                    <h5 class="unsaved-modal-title" :id="`${modalId}-title`">{{title}}</h5>
                    <p class="unsaved-modal-text">{{message}}</p>
                </div>

                <div class="modal-footer unsaved-modal-footer">
                    <button type="button" class="btn btn-outline-secondary" ref="stay" @click="answer(false)">
                        Continuar editando
                    </button>
                    <button type="button" class="btn btn-danger" @click="answer(true)">
                        {{discardLabel}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modalService from '@/utils/services/ModalService'

/**
 * "Descartar alterações?" com resposta por promise:
 *   if (await this.$refs.unsaved.ask()) { ...descarta }
 * O foco abre em "Continuar editando": o caminho seguro é o padrão.
 */
export default {
    name: 'UnsavedChangesModalCmp',
    props: {
        modalId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: 'Descartar alterações?',
        },
        message: {
            type: String,
            default: 'Você alterou informações que ainda não foram salvas. Se sair agora, elas serão perdidas.',
        },
        discardLabel: {
            type: String,
            default: 'Descartar',
        },
    },
    data() {
        return {
            resolver: null,
        }
    },
    methods: {
        ask() {
            return new Promise((resolve) => {
                this.resolver = resolve
                modalService.show(`#${this.modalId}`)
                setTimeout(() => this.$refs.stay && this.$refs.stay.focus(), 200)
            })
        },
        async answer(discard) {
            await modalService.hideAndWait(`#${this.modalId}`)

            if (this.resolver) {
                this.resolver(discard)
                this.resolver = null
            }
        },
    },
    beforeDestroy() {
        modalService.hide(`#${this.modalId}`)
    },
}
</script>

<style lang="scss" scoped>
.unsaved-modal {
    border: none;
    border-radius: 14px;
    background: var(--surface-overlay);
}

.modal-body {
    padding: 26px 24px 8px;
}

.unsaved-modal-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-bottom: 14px;
    border-radius: 50%;
    background: var(--warning-bg);
    color: var(--warning-fg);
}

.unsaved-modal-title {
    margin: 0 0 6px;
    color: var(--text-strong);
    font-weight: 800;
}

.unsaved-modal-text {
    margin: 0;
    color: var(--text-muted);
    line-height: 1.5;
}

.unsaved-modal-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 24px 20px;
    border-top: 0;

    .btn {
        margin: 0;
    }
}
</style>
